import { z } from 'zod';
import { ApiInterface } from '../../utilities/ApiInterface';
import { type Api, ApiFilterBuilder } from '@automapa/svelte-automapa-template';

// {"type": "optimal", "vehicle": {"load": 5, "width": 2.5, "height": 3, "length": 10, "weight": 12, "category": [1, 2, 3, 4], "euro_norm": [5]}}
export const RouteTypeAttributesSchema = z.object({
    type: z.string().describe('optimal, short, quick, easy, soft'),
    vehicle: z.object({
        weight: z.number().describe('tons'),
        load: z.number().describe('tons'),
        width: z.number().describe('meters'),
        length: z.number().describe('meters'),
        height: z.number().describe('meters'),
        category: z.array(z.number()).describe('vehicle category 1, 2, 3, 4'),
        euro_norm: z.array(z.number()).describe('euro norm 1, 2, 3, 4, 5, 6'),
    }),
    start_time: z
        .string()
        .regex(/^(\d{1,2}:\d{2})?$/)
        .catch('')
        .describe('HH:mm'),
});
export type RouteTypeAttributesType = z.infer<typeof RouteTypeAttributesSchema>;

export const RouteTypeRequestSchema = z.object({
    name: z.string().catch(''),
    attributes: RouteTypeAttributesSchema,
    active: z.boolean().catch(false),
});
export type RouteTypeRequestType = z.infer<typeof RouteTypeRequestSchema>;

export const RouteTypeResponseSchema = RouteTypeRequestSchema.merge(
    z.object({
        id: z.number(),
    })
);
export type RouteTypeResponseType = z.infer<typeof RouteTypeResponseSchema>;

export class RouteTypeApi extends ApiInterface {
    static _endpoint = 'route_types';

    public static async getAll(api: Api) {
        let f = new ApiFilterBuilder(null);
        return this._getAll<RouteTypeResponseType>(api, f, this._endpoint, RouteTypeResponseSchema);
    }

    public static async updateOne(api: Api, id: number, data: RouteTypeRequestType) {
        return this._updateOne<RouteTypeRequestType, RouteTypeResponseType>(
            api,
            id,
            this._endpoint,
            data,
            RouteTypeRequestSchema,
            RouteTypeResponseSchema
        );
    }
}
